export const approvalErrorMessage = (error) => {
    const status = error?.response?.status;
    if (status === 503) return 'خدمة الاعتماد غير متاحة حاليًا؛ لم يتم تسجيل موافقة. تواصل مع الورشة.';
    if (status === 404 || status === 410) return 'رابط الاعتماد غير موجود أو انتهت صلاحيته.';
    if (!status || status >= 500) return 'تعذر الاتصال بخدمة الاعتماد؛ حاول لاحقًا. لم يتم تأكيد أي موافقة.';
    const detail = error?.response?.data?.detail;
    return (typeof detail === 'string' ? detail : detail?.message) || 'تعذر تنفيذ طلب الاعتماد؛ تحقق من البيانات.';
};
